/*
 * Widżety zawsze korzystają z tych samych odmian Poppins, niezależnie od
 * fontów skonfigurowanych na stronie, na której zostały osadzone.
 * Stały identyfikator zapobiega dodaniu arkusza więcej niż jeden raz.
 */
const POPPINS_STYLESHEET_ID = 'coolturystki-poppins-font'

if (
  typeof document !== 'undefined' &&
  !document.getElementById(POPPINS_STYLESHEET_ID)
) {
  const fontStylesheet = document.createElement('link')

  fontStylesheet.id = POPPINS_STYLESHEET_ID
  fontStylesheet.rel = 'stylesheet'
  fontStylesheet.href =
    'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap'

  document.head.appendChild(fontStylesheet)
}

import './components/term-card/ct-term-card.js'
import './components/offer-terms/ct-offer-terms.js'
import './components/offer-summary/ct-offer-summary.js'
import './components/sticky-bar/ct-sticky-bar.js'
import './components/catalog/ct-offer-catalog.js'
import './components/recommendations/ct-recommended-programs.js'
import './components/trip-plan/ct-trip-plan.js'
import './components/price-inclusions/ct-price-inclusions.js'
import './components/flights-stay/ct-flights-stay.js'
import './components/trip-highlights/ct-trip-highlights.js'
